import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'

@Component({
	selector: 'generate-unit',
	templateUrl: './generate-unit.component.html',
	styleUrls: ['./generate-unit.component.scss']
})

export class GenerateUnitComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	@Input() unitIndex = 1
	@Input() unitForm!: FormGroup
	standalone = false
	
	@Input() unitID = 0
	@Input() unitName = 'Unidad de aprendizaje '
	@Input() courseID = 0
	@Input() courseName = ''
	@Input() dialog = false
	hours = 0
	lessons = 0

	imagesSearch = true
	videosSearch = true
	diagramsGenerate = true
	imagesPerHeading = 2
	videosPerLesson = 2
	diagramsPerLesson = 2

	generateSummary = true
	generateGlossary = true

	criteriaType = 'text'
	criteriaText = ''
	/*
	criteriaType = 'obj'
	criteriaText = 
	'C1: Reconocer y describir las instalaciones y los materiales que se emplean para la monta de un caballo\n' +
	'CE1.1 Describir las características de las instalaciones que se emplean para la monta de un caballo, señalando los posibles trabajos a realizar en cada una de ellas.\n' +
	'CE1.2 Describir los tipos de materiales que habitualmente se utilizan para fabricar las distintas partes de la pista de monta, señalando su disposición en la misma.\n' +
	'CE1.4 Citar los trabajos de acondicionamiento y mantenimiento de las instalaciones utilizadas para montar un caballo, así como los medios y materiales que se emplean para su realización.'
	*/

	studentProfile = ''
	additionalInstructions = ''

	loading = false
	success = false
	error = false
	loadingText = 'Generando contenido, espere por favor...'
	errorText = ''
	message = ''
	progress = 0
	duration = 0
	durationStr = ''
	
	showLogs = false
	logs = ''
	showResult = false
	result: any[] = []

	jobAddSub = new Subscription
	jobStatusSub = new Subscription

	constructor(private dataService: ApiService, private fb: FormBuilder) {}

	ngOnInit(): void {
		if (this.courseID == 1686) {
			console.log(this.unitID)
			this.unitName = 'Unidad de aprendizaje 1: Introducción a Microsoft Office 365'
			this.hours = 3
			this.criteriaText = 
			'o	Fundamentos\n' + 
			'o	Características de Microsoft 365\n' + 
			'o	Planes de Microsoft 365\n' + 
			'o	Ventajas de Microsoft 365\n' + 
			'o	Acceso y entorno de Microsoft 365\n'
		}

		if (!this.unitForm) {
			this.standalone = true
			this.unitForm = this.createUnitForm()
		}

		this.unitForm.get('name')?.setValue(this.unitName)

		this.unitForm.get('hours')?.valueChanges.subscribe(value => {
			this.hours = value
			this.calcLessons()
		})

		// if (this.courseName.startsWith('UF') || this.courseName.startsWith('MF')) this.criteriaType = 'obj'
		// else this.criteriaType = 'text'

		if (this.hours > 0) this.calcLessons()
	}

	ngAfterViewInit(): void {
		
	}

	ngOnChanges(): void {
		
	}

	ngOnDestroy(): void {
		this.jobAddSub?.unsubscribe()
		this.jobStatusSub?.unsubscribe()
	}

	createUnitForm(): FormGroup {
		return this.fb.group({
			name: 					[this.unitName,				[Validators.required]],
			hours: 					[this.hours, 				[Validators.required, Validators.min(1)]],
			lessons: 				[this.lessons, 				[Validators.required, Validators.min(1)]],
			imagesSearch: 			[this.imagesSearch, 		[Validators.required]],
			imagesPerHeading: 		[this.imagesPerHeading, 	[Validators.required]],
			videosSearch: 			[this.videosSearch, 		[Validators.required]],
			videosPerLesson: 		[this.videosPerLesson, 		[Validators.required]],
			diagramsGenerate:		[this.diagramsGenerate, 	[Validators.required]],
			diagramsPerLesson:		[this.diagramsPerLesson, 	[Validators.required]],
			generateSummary: 		[this.generateSummary, 		[Validators.required]],
			generateGlossary: 		[this.generateGlossary, 	[Validators.required]],
			criteriaText: 			[this.criteriaText, 		[Validators.required]],
			studentProfile: 		[this.studentProfile],
			additionalInstructions:	[this.additionalInstructions],
		})
	}

	calcLessons() {
		// this.lessons = Math.round(this.hours * 0.55)
		this.lessons = Math.round(this.hours * 0.9)
		this.unitForm.get('lessons')?.setValue(this.lessons)
	}

	generateUnit() {
		this.unitName = this.unitForm.get('name')?.value
		this.criteriaText = this.unitForm.get('criteriaText')?.value
		this.imagesSearch = this.unitForm.get('imagesSearch')?.value
		this.videosSearch = this.unitForm.get('videosSearch')?.value
		this.imagesPerHeading = this.unitForm.get('imagesPerHeading')?.value
		this.videosPerLesson = this.unitForm.get('videosPerLesson')?.value
		this.generateSummary = this.unitForm.get('generateSummary')?.value
		this.generateGlossary = this.unitForm.get('generateGlossary')?.value
		this.studentProfile = this.unitForm.get('studentProfile')?.value
		this.additionalInstructions = this.unitForm.get('additionalInstructions')?.value

		// console.log(this.unitID)
		// console.log(this.unitName)
		// console.log(this.courseID)
		// console.log(this.hours)
		// console.log(this.criteriaText)

		this.errorText = ''
		this.logs = ''
		this.message = 'Iniciando...'
		this.result = []

		if (this.unitName == '') {
			this.errorText = 'El nombre de la unidad no puede estar vacío.'
		} else if (this.hours == 0) {
			this.errorText = 'El número de horas debe ser mayor a 0.'
		} else if (this.criteriaText.length == 0) {
			this.errorText = 'Los criterios de aprendizaje no pueden estar vacíos.'
		}

		/*
		if (this.unitName == '') {
			this.errorText = 'El nombre de la unidad no puede estar vacío.'
		} else if (this.hours == 0) {
			this.errorText = 'El número de horas debe ser mayor a 0.'
		} else if (this.criteriaType == '') {
			this.errorText = 'No se ha seleccionado un tipo de criterio de aprendizaje.'
		} else if (this.criteriaText.length == 0) {
			this.errorText = 'Los criterios de aprendizaje no pueden estar vacíos.'
		}
		*/

		if (this.errorText.length > 0) {
			this.loading = false
			this.success = false
			this.error = true
			return
		}

		this.loading = true
		this.success = false
		this.error = false

		let command = 'unit_generate'
		let data = {
			'unit_id': this.unitID,
			'unit_name': this.unitName,
			'course_id': this.courseID,
			'course_name': this.courseName,
			'hours': this.hours,
			'lessons': this.lessons,
			'images_search': this.imagesSearch,
			'videos_search': this.videosSearch,
			'images_per_heading': this.imagesPerHeading,
			'videos_per_lesson': this.videosPerLesson,
			'generate_summary': this.generateSummary,
			'generate_glossary': this.generateGlossary,
			'criteria_type': this.criteriaType,
			'criteria_text': this.criteriaText,
			'student_profile': this.studentProfile,
			'additional_instructions': this.additionalInstructions,
		}

		this.jobAddSub = this.dataService.jobAdd(command, data)
		.subscribe({
			next: jobId => {
				console.log(jobId)

				let interval = setInterval(() => {
					this.jobStatusSub = this.dataService.jobStatus(jobId)
					.subscribe({
						next: data => {
							console.log(data)
							let status = data.status
							
							this.message = data.message
							this.progress = data.progress
							this.duration = data.duration
							this.durationStr = new Date(data.duration * 1000).toISOString().slice(11, 19)

							this.logs = data.logs
							this.result = data.result

							if (status == 'completed' || status == 'failed') {
								clearInterval(interval)
								if (status == 'completed') {
									this.loading = false
									this.success = true
									this.error = false
								} else if (status == 'failed') {
									this.loading = false
									this.success = false
									this.error = true
								}
							}
						},
						error: e => {
							console.log(e)
							clearInterval(interval)
							this.loading = false
							this.success = false
							this.error = true
						}
					})
				}, 5000)
			},
			error: e => {
				console.log(e)
				this.loading = false
				this.success = false
				this.error = true
			}
		})
	}

}
